import { IActivityModel } from '../Entities/Activity/Activity';
import * as dateFns from 'date-fns';

type ActivityFields =
  | 'isAdvertisement'
  | 'isFocus'
  | 'admStatus'
  | 'lastEnrollmentDate'
  | 'lastEnrollmentDateEndTime'
  | 'createdDate'
  | 'publicationDate';

interface IPartialActivity extends Pick<IActivityModel, ActivityFields> {
  filterFromCourseCarousel?: IActivityModel['filterFromCourseCarousel'];
}

export const isActivityNew = (date: string | Date): boolean => {
  if (typeof date === 'string') {
    date = new Date(date);
  }

  return dateFns.isAfter(dateFns.addDays(date, 5), Date.now());
};

export default function getActivityStatus(act: IPartialActivity) {
  // For comparing if the LastEnrollmentDate has been passed
  const convertDate: Date = new Date(
    `${act.lastEnrollmentDate}T${act.lastEnrollmentDateEndTime}`
  );
  if (act.filterFromCourseCarousel) {
    return 'filteredFromCourseCarousel';
  }
  if (act.isAdvertisement) {
    return 'isAdvertisement';
  } else if (act.admStatus === 'K') {
    return 'isCancelled';
  } else if (act.isFocus) {
    return 'isFocus';
  } else if (dateFns.isAfter(new Date(), new Date(convertDate))) {
    return 'lastEnrollmentDatePassed';
  } else if (
    dateFns.isAfter(
      dateFns.addDays(new Date(), 4),
      new Date(act.lastEnrollmentDate)
    )
  ) {
    return 'lastChance';
  } else if (
    dateFns.isAfter(dateFns.addDays(new Date(act.publicationDate || act.createdDate), 5), Date.now())
  ) {
    return 'success';
  }

  return '';
}



// WEBPACK FOOTER //
// ./src/utils/activityStatusUtils.ts